import React, { CSSProperties, FC } from "react";
import appConfig from "../../util/appConfig";
import checkMark from "../../assets/images/checkMark.svg";
import style from "./style.module.scss";
// import parse from "html-react-parser";
import parseHtmlFromText from "../../util/parseHtmlFromText";

interface ICheckboxV2 {
  value: boolean | string;
  text: string;
  onChange: () => void;
  isValid?: boolean;
  isValided?: boolean;
  customStyle?: CSSProperties;
  customTextStyle?: CSSProperties;
  customOpacity?: number;
  isDisabled?: boolean;
  ariaLabel?: string;
  width?: string;
}

export const CheckboxV2: FC<ICheckboxV2> = ({
  onChange,
  text,
  value,
  isValid = true,
  isValided = false,
  customStyle,
  customOpacity = 0.2,
  isDisabled = false,
  ariaLabel = "",
  width,
  customTextStyle = {},
}) => {
  return (
    <div
      className={style.wrapper}
      style={{
        ...customStyle,
        opacity: isDisabled ? 0.5 : "",
        width: width ? width : "",
      }}
    >
      <div
        className={style.checkBox}
        role="checkbox"
        aria-checked={!!value}
        tabIndex={isDisabled ? -1 : 0}
        style={{
          backgroundColor: value ? appConfig.mainColor : "#8F9EA9",
          opacity: value ? 1 : customOpacity ? customOpacity : 0.2,
          border: isValided && !value ? "2px solid #de3745" : "",
          flexShrink: 0,
          flexGrow: 0,
        }}
        onClick={onChange}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onChange();
          }
        }}
        aria-label={ariaLabel}
      >
        {value ? (
          <img className={style.checkedImg} src={checkMark} alt="check" />
        ) : null}
      </div>
      <div
        onClick={onChange}
        className={style.text}
        style={{
          color: isValided && !value ? "#de3745" : "",
          ...customTextStyle,
        }}
      >
        {parseHtmlFromText(text)}
        {/* {parse(text)} */}
      </div>
    </div>
  );
};
